import {
  CampaignIndexModalType,
  useCampaignIndexModalContext,
} from 'modules/campaignIndex/campaignFolders/contexts/CampaignIndexModalContext';
import { useDisableCampaignAlerts } from 'modules/campaignIndex/hooks';
import { BUTTON_SIZES, DestructiveButton } from 'ui/button';
import { MODAL_SIZES, MODAL_VARIANTS, Modal, ModalBody, ModalFooter, ModalHeader } from 'ui/modal';

export const CONFIRM_DISABLE_ALERTS_MODAL_TEST_ID = 'confirm-disable-alerts-modal';
export const CONFIRM_DISABLE_ALERTS_BUTTON_TEST_ID = 'confirm-disable-alerts-button';

export const ConfirmDisableAlertsModal = ({
  campaignId,
  campaignName,
}: {
  campaignId: number;
  campaignName: string;
}) => {
  const { closeModal } = useCampaignIndexModalContext();
  const { disableAlerts, isLoading } = useDisableCampaignAlerts(
    { campaignId, campaignName },
    {
      onCompleted: () => closeModal(CampaignIndexModalType.ConfirmDisableAlertsModal),
    },
  );

  return (
    <Modal
      withPortal
      isModalOpen={true}
      onClose={() => closeModal(CampaignIndexModalType.ConfirmDisableAlertsModal)}
      id="deactivate-modal"
      data-test={CONFIRM_DISABLE_ALERTS_MODAL_TEST_ID}
      size={MODAL_SIZES.SMALL}
      variant={MODAL_VARIANTS.WARNING}
    >
      <ModalHeader>Disable alerts?</ModalHeader>
      <ModalBody>
        You’re about to disable alerts for 1 campaign. You can enable alerts again by editing the
        campaign.
      </ModalBody>
      <ModalFooter>
        <DestructiveButton
          data-test={CONFIRM_DISABLE_ALERTS_BUTTON_TEST_ID}
          onClick={disableAlerts}
          isLoading={isLoading}
          size={BUTTON_SIZES.LARGE}
        >
          Disable alerts
        </DestructiveButton>
      </ModalFooter>
    </Modal>
  );
};
